import React from "react";

const OPPunctuality = () => {
  return <div> OPPunctuality</div>;
};
export default OPPunctuality;
